
<svg viewBox="0 0 112 112">
  <path
    d="M112 4.667v102.666c0 1.264-.462 2.358-1.385 3.282-.924.923-2.018 1.385-3.282 1.385H4.667c-1.264 0-2.358-.462-3.282-1.385C.462 109.69 0 108.597 0 107.333V4.667c0-1.264.462-2.358 1.385-3.282C2.31.462 3.403 0 4.667 0h102.666c1.264 0 2.358.462 3.282 1.385.923.924 1.385 2.018 1.385 3.282z"
    fill="currentColor"
    fill-rule="nonzero"
  />
</svg>
